/* c8 ignore start */
import { ContentfulAsset } from '@ravago/shared/page-data/models/contentful';

import { Asset } from 'contentful';

export class AssetUtils {
  static optimizeImageIfRequired(src: string, acceptWebp?: boolean, width?: number, maxWidth?: number): string {
    try {
      const parsedUrl = new URL(this.asHttps(src));

      /**
       * By Default, Next.js optimizes images with the `next/image` component and adds query parameters like `?fm=webp` or `?w=width`.
       * If the image is an SVG, we do not need these parameters, so we remove them when the image is an SVG.
       */
      if (parsedUrl.pathname.endsWith('.svg')) {
        parsedUrl.search = '';

        return parsedUrl.toString();
      }

      if (!src || !src.includes('images.ctfassets')) return src;

      let optimizedSrc = src;

      if (!src.includes('?fm=') && !src.includes('&fm=') && acceptWebp) {
        optimizedSrc = `${optimizedSrc}${optimizedSrc.includes('?') ? '&' : '?'}fm=webp`;
      }

      if (!src.includes('?w=') && !src.includes('&w=') && width) {
        const calculatedWidth = maxWidth && width > maxWidth ? maxWidth : width;
        optimizedSrc = `${optimizedSrc}${optimizedSrc.includes('?') ? '&' : '?'}w=${calculatedWidth}`;
      }

      return this.asHttps(optimizedSrc);
    } catch (e) {
      return this.asHttps(src); // fallback if URL is invalid
    }
  }

  // Contentful image urls never include a protocol so we need to ensure they are always https.
  // @see: https://github.com/vercel/next.js/issues/18536
  static asHttps(src: string): string {
    return src.startsWith('https:') ? src : `https:${src}`;
  }

  static mapToImage(item?: Asset): ContentfulAsset | undefined {
    if (!item?.fields) return undefined;

    return {
      sys: {
        id: item.sys.id
      },
      title: item.fields.title,
      url: item.fields.file.url,
      width: item.fields.file.details.image?.width,
      height: item.fields.file.details.image?.height
    };
  }
}
/* c8 ignore stop */
